import { Typography, Stack } from '@mui/material'
import { CalendarBlank, Icon } from '@phosphor-icons/react'
import { DateString, isoDateStringToLocalFormat } from 'ComponentLibrary/src/common/date'
import { TypographyProps } from 'ComponentLibrary/src/piazza/text/Typography/Typography'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { defaults } from 'lodash'

type DateWithIconProps = {
    date: DateString | undefined
    iconColor?: string
    noDateText?: string
    CalendarIconComponent?: Icon
    typographyProps?: Partial<Pick<TypographyProps, 'variant' | 'color'>>
    locale?: string
}

export function DateWithIcon({
    date,
    noDateText,
    iconColor = tokens.ColorIconDefault,
    CalendarIconComponent = CalendarBlank,
    typographyProps,
    locale = 'de-DE',
}: DateWithIconProps) {
    const typographyPropsWithDefaults = defaults({}, typographyProps, { variant: 'textM', color: tokens.ColorTextBold })

    return (
        <Stack alignItems="center" gap={tokens.SizingSpacing075} direction="row">
            <CalendarIconComponent color={iconColor} size={tokens.SizingIconS} weight="bold" />
            <Typography {...typographyPropsWithDefaults}>{date ? isoDateStringToLocalFormat(date, false, locale) : noDateText}</Typography>
        </Stack>
    )
}
